<template>
  <v-container :class="containerClass" fluid>
    <v-row>
      <v-col cols="12">
        <v-alert text color="warning" icon="mdi-information-outline">
          <strong>
            Please complete each class study progress by the end of class
          </strong>
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <today-class-schedules
          :items="todaySchedules"
          :loading="isScheduleListLoading"
        >
        </today-class-schedules>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <calendar-class-schedules :items="thisWeekSchedules" type="week">
          <template #header> This Week Class Schedules </template>
        </calendar-class-schedules>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <class-schedules
          :items="incompletedSchedules"
          :loading="isScheduleListLoading"
        >
          <template #header> Pending Study Progresses </template>
          <template #subheader>
            Please complete study progresses for each class schedule after
            finished
          </template>
          <template #nodata> No pending study progresses</template>
        </class-schedules>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import { mapGetters, mapActions } from 'vuex'
import TodayClassSchedules from '@components/Dashboard/TodayClassSchedules.vue'
import ClassSchedules from '@components/Dashboard/ClassSchedules.vue'
import CalendarClassSchedules from '@components/Dashboard/CalendarClassSchedules.vue'

export default {
  name: 'Dashboard',
  components: {
    TodayClassSchedules,
    ClassSchedules,
    CalendarClassSchedules,
  },
  layout: LayoutDashboard,
  computed: {
    ...mapGetters({
      authUser: 'authUser',
      scheduleList: 'dashboard/classroomSchedule/thisMonthList',
      isScheduleListLoading:
        'dashboard/classroomSchedule/isThisMonthListLoading',
      incompletedScheduleList: 'dashboard/classroomSchedule/incompletedList',
      isIncompletedScheduleListLoading:
        'dashboard/classroomSchedule/isIncompletedListLoading',
    }),
    schedules() {
      return this.scheduleList.data
    },
    todaySchedules() {
      const today = moment()
      return this.schedules.filter((e) => {
        return moment(e.class_date).isSame(today, 'day')
      })
    },
    thisWeekSchedules() {
      const startDate = moment().startOf('week')
      const endDate = moment().endOf('week')
      return this.schedules.filter((e) => {
        const dt = moment(e.class_date)
        return dt.isSameOrAfter(startDate) && dt.isSameOrBefore(endDate)
      })
    },
    incompletedSchedules() {
      return this.incompletedScheduleList.data
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      getSchedules: 'dashboard/classroomSchedule/getThisMonthList',
      getIncompletedSchedules: 'dashboard/classroomSchedule/getIncompletedList',
    }),
    async init() {
      const classSchedulesFilter = {
        teacher_id: this.authUser.account_id,
        class_status: 'ACTIVE',
      }
      await Promise.all([
        this.getSchedules(classSchedulesFilter),
        this.getIncompletedSchedules(classSchedulesFilter),
      ])
    },
  },
}
</script>
